import { graphql } from 'gatsby';
import React from 'react';
import Container from '../components/layout/Container/Container';
import PageLayout from '../components/layout/PageLayout/PageLayout';
import PageSection from '../components/layout/PageSection/PageSection';
import Divider from '../components/ui/Divider/Divider';
import HomeBanner from '../components/ui/Home/HomeBanner/HomeBanner';
import MoreArticles from '../components/ui/Home/MoreArticles/MoreArticles';
import PostsPerTopic from '../components/ui/Home/PostsPerTopic/PostsPerTopic';
import Topics from '../components/ui/Home/Topicos/Topics';
import { PostsSelector } from '../components/utils/PostsSelector';
import Seo from '../components/utils/Seo';
import { useAnimationOnScroll } from '../components/utils/useAnimateOnScroll';
import { Direction } from '../globals';
import './index.scss';

interface HomeProps {
    data: {
        homeYaml: {
            about_section: AboutSectionBlock[];
            tabs_posts: PostsPerTopicBlock[];
        };
        allMdx: {
            nodes: PostDetails[];
        };
        topicsYaml: {
            topics: TopicDetails[];
        };
    };
}

const Home: React.FC<HomeProps> = ({ data }: HomeProps) => {
    const postsSelector = new PostsSelector(data.allMdx.nodes);
    useAnimationOnScroll();
    return (
        <PageLayout>
            <Seo isPost={false} />
            {/* <AnnouncementHeader /> */}
            <HomeBanner horizontalCarouselTopics={data.topicsYaml.topics} />
            <PageSection className="posts-per-topic-section">
                <Container>
                    <div className="section-text">
                        <h2>Principais Artigos</h2>
                    </div>

                    <PostsPerTopic
                        {...postsSelector.getByTopic(data.homeYaml.tabs_posts)}
                    />
                </Container>
            </PageSection>

            <Divider direction={Direction.horizontal} />
            <PageSection className="topic-section">
                <Container>
                    <div className="section-text">
                        <h2>Artigos por tópico</h2>
                    </div>
                    <Topics topics={data.topicsYaml.topics} />
                </Container>
            </PageSection>

            <Divider direction={Direction.horizontal} />
            <PageSection className="more-articles-section">
                <Container>
                    <div className="section-text">
                        <h2>Últimos Artigos</h2>
                    </div>
                    <MoreArticles
                        posts={data.allMdx.nodes.map(
                            (node) => node.frontmatter
                        )}
                    />
                </Container>
            </PageSection>
        </PageLayout>
    );
};

export const homeQuery = graphql`
    {
        homeYaml {
            tabs_posts {
                posts
                topic
            }
            about_section {
                desc
                icon
                title
            }
        }
        allMdx(
            filter: { frontmatter: { layout: { eq: "BlogPage" } } }
            sort: { fields: frontmatter___modifiedAt, order: DESC }
        ) {
            nodes {
                frontmatter {
                    author
                    description
                    image {
                        childImageSharp {
                            fluid {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                    layout
                    suburl
                    tags
                    title
                }
            }
        }
        topicsYaml {
            topics {
                desc
                title
                url
                logo
            }
        }
    }
`;

export default Home;
